import '../create_team_header/index.css';
import { Text, View } from '../../../component';
import useTheme from '../../../utilities/hooks/theme';
import I18n from '../../../utilities/locale';
import React from 'react';
import CreateTeamTabBar from '../../component/create_team_tab_bar';
const CreateTeamHeaderFootball = ({
  totalCreditCount,

  isSubstituteTeamPlayer = false,
  onChangeTab,
  activeTab,
  counts,
  routes,
  onPressTeamPreview,
  onPressContinue
}: any) => {
  const { FantasyTheme: theme } = useTheme();

  const totalCount = counts['G/K'] + counts['DEF'] + counts['MID'] + counts['ST'];
  let gkCount = counts['G/K'];
  let defCount = counts['DEF'];
  let midCount = counts['MID'];
  let stCount = counts['ST'];
  const playerCountList = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  const maxTeamMsg = {
    color: theme.createTeamHeaderMaxTeamMsg
  };

  const headerPlayerCount = {
    color: theme.createTeamTotalPlayerCount
  };
  const headerPlayerValue = {
    color: theme.createTeamTotalPlayerValue
  };
  const headerType = {
    color: theme.createTeamPlayerTypeTitle
  };

  const pick1 = {
    color: theme.createTeamSelectPlayerTitle
  };
  const selectedTab = activeTab;
  const pickLabel =
    selectedTab === 0
      ? I18n.t('PickGoalKeeper')
      : selectedTab === 1
      ? I18n.t('PickDefender')
      : selectedTab === 2
      ? I18n.t('PickMidfielder')
      : I18n.t('PickForward');

  const pickLabelMessage =
    selectedTab === 0
      ? I18n.t('PickGoalKeeperMaxMessage')
      : selectedTab === 1
      ? I18n.t('PickDefenderMaxMessage')
      : selectedTab === 2
      ? I18n.t('PickDefenderMaxMessage')
      : I18n.t('PickForwardMaxMessage');
  const createTeamSelectionStyle = {
    background: theme.createTeamSelectionBoxbg
  };
  const previewBtnStyle = {
    border: `2px solid ${theme.createTeamPreviewBtnLabel}`,
    backgroundColor: theme.createTeamPreviewBtn,
    color: theme.createTeamPreviewBtnLabel
  };
  const saveBtnStyle = {
    backgroundColor: theme.createTeamPreviewBtnLabel
  };
  return (
    <>
      <div style={{ position: 'sticky', right: '10px', top: '10px' }}>
        <View className={'create-team-header-container'} style={createTeamSelectionStyle}>
          <View className={'create-team-tab-content-pick-player-wrapper'}>
            <Text className={'create-team-tab-content-pick-label'} style={pick1}>
              {`${pickLabel}`}
            </Text>
            <Text className={'create-team-tab-content-pick-message'} style={pick1}>
              &nbsp;&nbsp;-&nbsp;&nbsp;{pickLabelMessage}
            </Text>
          </View>
          <View className={'create-team-header-player-type-wrapper'}>
            <View className={'create-team-header-tab-item-container'}>
              <CreateTeamTabBar
                onChangeTab={onChangeTab}
                activeTab={activeTab}
                counts={counts}
                routes={routes}
              />
            </View>
          </View>
          <View className={'create-team-header-player-type-list-wrapper'}>
            {playerCountList.map((item, index) => {
              let title = '';
              if (gkCount > 0) {
                title = 'G/K';
                gkCount--;
              } else if (defCount > 0) {
                title = 'DEF';
                defCount--;
              } else if (midCount > 0) {
                title = 'MID';
                midCount--;
              } else if (stCount > 0) {
                title = 'ST';
                stCount--;
              }
              return (
                <View
                  key={index}
                  className={'create-team-header-player-list-item'}
                  style={{
                    backgroundColor:
                      title.length > 0
                        ? theme.createTeamSelectedPlayerType
                        : theme.createTeamDefaultPlayerType,
                    borderColor:
                      title.length > 0
                        ? theme.createTeamPlayerTypeActiveBorder
                        : theme.createTeamPlayerTypeDefaultBorder
                  }}>
                  <Text className={'create-team-header-player-list-item-text'} style={headerType}>
                    {title}
                  </Text>
                </View>
              );
            })}
          </View>
          <View
            className={'create-team-header-item-wrapper'}
            style={{
              ...createTeamSelectionStyle,
              borderTop: `1px solid ${theme.createTeamTabBarBorder}`
            }}>
            <View
              className={'create-team-header-player-wrapper'}
              style={{ borderRight: `1px solid ${theme.createTeamTabBarBorder}` }}>
              <View className={'create-team-header-player-content'}>
                <Text className={'create-team-header-player-count'} style={headerPlayerCount}>
                  {`${totalCount}/`}
                </Text>
                <Text className={'create-team-header-player-value'} style={headerPlayerValue}>
                  {'11'}
                </Text>
              </View>
              <Text className={'create-team-header-player-title'} style={headerPlayerValue}>
                {'Players'}
              </Text>
            </View>
            {isSubstituteTeamPlayer ? (
              <Text className={'create-team-header-select-substitute'} style={maxTeamMsg}>
                {'Select Your Substitutes'}
              </Text>
            ) : (
              <Text className={'create-team-header-max-msg'} style={maxTeamMsg}>
                {I18n.t('MaxPlayers')}
              </Text>
            )}
            <View
              className={'create-team-header-player-wrapper'}
              style={{ borderLeft: `1px solid ${theme.createTeamTabBarBorder}` }}>
              <Text
                className={'create-team-header-player-count'}
                style={headerPlayerCount}>{`${totalCreditCount}`}</Text>
              <Text className={'create-team-header-player-title'} style={headerPlayerValue}>
                {'Credits'}
              </Text>
            </View>
          </View>
        </View>
        <div className="create-team-save-preview-btn-container">
          <button
            className="create-team-priview-btn"
            style={previewBtnStyle}
            onClick={onPressTeamPreview}>
            Preview
          </button>
          <button className="create-team-save-btn" style={saveBtnStyle} onClick={onPressContinue}>
            Continue
          </button>
        </div>
      </div>
    </>
  );
};
export default React.memo(CreateTeamHeaderFootball);
